import {IDirective, IScope} from "angular";

interface ElementHeightCallbackDirectiveScope extends IScope {
    elementCallback: (element: JQLite) => void;
}

export const ElementHeightCallbackDirective = [(): IDirective => {
    return {
        scope: {
            elementCallback: '<'
        },
        link: {
            post: (scope: ElementHeightCallbackDirectiveScope, element, attr) => {
                scope.elementCallback(element);
            }
        }
    }
}];